import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` A minimum SDK version of v1.207.8 is required, but we recommend keeping `}<a parentName="p" {...{
          "href": "/docs/sdk-doctor"
        }}>{`up to date with the latest version`}</a>{` to ensure you have all of error tracking's features.`}</p>
    </blockquote>
    <p>{`You can enable exception autocapture for the JavaScript Web SDK in the `}<strong parentName="p">{`Error tracking`}</strong>{` section of `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project-error-tracking#exception-autocapture"
      }}>{`your project settings`}</a>{`. `}</p>
    <p>{`When enabled, this automatically captures `}<inlineCode parentName="p">{`$exception`}</inlineCode>{` events when errors are thrown by wrapping the `}<inlineCode parentName="p">{`window.onerror`}</inlineCode>{` and `}<inlineCode parentName="p">{`window.onunhandledrejection`}</inlineCode>{` listeners.`}</p>
    <h4 {...{
      "id": "manual-error-capture"
    }}>{`Manual error capture`}</h4>
    <p>{`It is also possible to manually capture exceptions using the `}<inlineCode parentName="p">{`captureException`}</inlineCode>{` method:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`posthog.captureException(error, additionalProperties)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      